import { callService, callServiceWithCredentials } from "../../services/services";
import { stateHandler } from "../../utils/enums";
import { updateAlert } from "../alert/actions";
import { addProcessContext } from "../processContext/actions";

export const sendApplicantCompany = (body) => {
  return async (dispatch) => {
    return await callServiceWithCredentials("applicantCompany", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          //const result = stateHandler(data.appState);
          dispatch(addProcessContext(data));
          return {
            appState: data.appState,
            appReferenceNo: data.appReferenceNo,
            limitAmount: data.limitAmount,
            shopUrl: data.shopUrl
          };
        } else {
          throw data.errorExplanation ? data.errorExplanation : data.errorText;
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return { nextStatus: true, result: "1", msg: err };
      });
  };
};

export const getCustAutoCompleteInfo = (body) => {
  return async (dispatch) => {
    return await callService("getCustAutoCompleteInfo", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          return {...response};
        } else {
          throw data;
        }
      })
      .catch((err) => {
        let errText = "";
        if (err.errorExplanation) {
          errText = err.errorExplanation;
        } else if (err.errorText) {
          errText = err.errorText;
        }
        if(err.errorCode !== "ERR0026") {
          dispatch(
            updateAlert({
              severity: "error",
              text: errText,
              open: true,
            })
          );
          return { nextStatus: false, result: "1", msg: errText };
        } else {
          return { nextStatus: true, result: "1", msg: errText };
        }
        
        
      });
  };
};

export const getByUUID = (body) => {
  return async (dispatch) => {
    return await callService("getByUUID", body, dispatch, body.uuid)
      .then((response) => {
        const data = response.data;
        if (data.companyCode && data.companyCode !== "") {
          dispatch(addProcessContext(data));
          return {
            ...stateHandler(data.appState),
            appState: data.appState,
            appReferenceNo: data.appReferenceNo,
            productType: data.productType,
            companyCode: data.companyCode,
            expiryDate: data.expiryDate,
            expiryTime: data.expiryTime,
            sessionId: data.sessionId,
            isWaitingPage: data.isWaitingPage
          };
        } else {
          throw response.data;
        }
      })
      .catch((err) => {
        let errText = "";
        if (err.errorExplanation) {
          errText = err.errorExplanation;
        } else if (err.errorText) {
          errText = err.errorText;
        }
        dispatch(
          updateAlert({
            severity: "error",
            text: errText,
            open: true,
          })
        );
        return { nextStatus: true, result: "1", msg: errText };
      });
  };
};
